import token from '@/storage/token.js'
import api from '@/api/index'
import { Message } from 'element-ui';
import router from '@/router/index.js'

export default {
  namespaced: true,
  getters: {
    is_login (state, getters, rootState, rootGetters) {
      console.log('is_login')
      return state.is_login
    },
    account_info (state, getters, rootState, rootGetters) {
      console.log('account_info')
      return state.account_info
    },
  },
  state: {
    is_login: false,
    account_info: {},
  },
  mutations: {
    mutation_is_login (state, payload) {
      console.log('mutation_is_login: state=', state, ', payload=', payload)
      state.is_login = payload === true? true: false
    }
  },
  actions: {
    async action_login ({ dispatch, commit, state }, { email, password }) {
      console.log('action_login: email:', email, ', password:', password)
      let res = await api.login(email, password)
      console.log('res', res)

      if (res.success) {
        commit('mutation_is_login', true)
        state.account_info = Object.assign({}, res.payload)
        token.setToken(res.payload.session_id)

        // #216
        if(res.payload && res.payload.reset_pwd === true){
          Message.warning(res.message)
          commit('mutation_is_login', false)
          router.push({
            path: `/backstage/reset?acc=${email}`,
            query: {}
          })
        }
      }else {
        commit('mutation_is_login', false)
        state.account_info = {}
        token.setToken(null)
      }
    },
    async action_logout ({ dispatch, commit, state }, payload) {
      console.log('action_logut')
      await api.logout()
      commit('mutation_is_login', false)
      token.setToken(null)
    },
    async action_get_personal_info ({ dispatch, commit, state }, payload) {
      console.log('action_get_personal_info')
      let res = await api.get_personal_info()

      if (res.success) {
        commit('mutation_is_login', true)
        state.account_info = Object.assign({}, res.payload)
      }
      else {
        commit('mutation_is_login', false)
        state.account_info = {}
        token.setToken(null)
      }
    },
  }
}